export default __webpack_public_path__ + "static/media/img_mv_program_illustration_x2.609d18df.png";